import * as React from 'react';
import { IconProps } from '~/components/atoms/icon/iconProps';

const XMarkIcon: React.FC<IconProps & React.SVGProps<SVGSVGElement>> = ({
    width = 18,
    height = 18,
    fill = 'none',
    ...props
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill={fill}
        viewBox="0 0 34 34"
        aria-hidden="true"
        {...props}
    >
        <path
            fill="currentColor"
            d="M26.833 8.998L24.836 7l-7.92 7.92L8.999 7 7 8.998l7.92 7.919L7 24.836l1.998 1.997 7.919-7.919 7.919 7.92 1.997-1.998-7.919-7.92 7.92-7.918z"
        />
    </svg>
);

export default XMarkIcon;
